import { post,get } from "@/api/request"

export const getClass = params => post("/v1/recommend/organ/banner", params)
export const getBrand = params => post("/v1/recommend/organ/brand", params)
export const getOrgNews = params => get("https://news-api.artron.net/api/v7_news/auction_list", params)
export const getOrgList = params => post("/v1/recommend/organs", params)

//拍卖黄页列表
export const getSearchOrg = params => post("/v1/recommend/organ/search", params)
//拍卖黄页meta
export const getBrandMeta = params => post("/v1/search/meta", params)

